import React , {useState , useEffect} from 'react';
import { useLocation } from "react-router-dom";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Logo from "../../assets/images/logo.jpg";
import Burger from "../../assets/images/Burger.png"
import close from "../../assets/images/close.png"
// import Sidebar from "../Sidebar/Sidebar.js";
import {Navigation} from 'react-minimal-side-navigation';
import 'react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css';

import {Link} from "react-router-dom";
import $ from 'jquery';
function Head(){
 
  $(window).scroll(function(){
    if ($(this).scrollTop()) {
       $('nav').addClass('scroll');
    } else {
       $('nav').removeClass('scroll');
    }
}); 
useEffect(() => {
     window.scrollTo(0, 0)
   }, [])
const[show,setShow]=useState(false);


  $(document).ready(function () {
  
  $(".one").click(function (){
    $(this).addClass("active").siblings().removeClass("active");
  });
});
  if(show == true){

    $('body').addClass('overflowbody');
    }
    else {
      $('body').removeClass('overflowbody');
    }
const location = useLocation();

useEffect(() => {
  // Close sidebar on route change
  if (isOpen) {
    ToggleSidebar();
  }
}, [location]);

    const [isOpen, setIsOpen] = useState(false);

const ToggleSidebar = () => {
  setIsOpen((prev) => !prev);
};


        
   
return(

<>
<nav className="navbar" id="navbar">
  <div className="container-fluid custom-container">
    <div className='d-flex logo_img'>
      <Link className="navbar-brand navimage" to="/">
      <img src={Logo} />
      </Link>
    </div>
    <div className="homelinks homelinks_desktop">
      <ul class="main-menu">
        <li class="main-menu-li">
          <Link to="/" class="main-menu-main-links active">Home</Link>
        </li>
        <li class="main-menu-li">
          <Link to="/Vision" class="main-menu-main-links">Our Vision/Mission</Link>
        </li>
        <li class="main-menu-li">
          <Link to="/About" class="main-menu-main-links">About Us</Link>
        </li>
        <li class="main-menu-li">
          <Link to="/Team" class="main-menu-main-links">Our Team</Link>
        </li>
        <li class="main-menu-li">
          <Link to="/GetInvolved" class="main-menu-main-links">Get Involved</Link>
        </li>
        <li class="main-menu-li">
          <Link to="/Gallery" class="main-menu-main-links">Gallery </Link>
        </li>
        <li class="main-menu-li">
          <Link to="/Events" class="main-menu-main-links">Events </Link>
        </li>
        <li class="main-menu-li">
          <Link to="/Contact" class="main-menu-main-links">Contact Us </Link>
        </li>
      </ul>
    </div>
    <div className="homelinks">
       <Link to="/Donate"><button class="button_svg"> Donate Now <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
          <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z" clip-rule="evenodd"></path>
        </svg>
      </button></Link>
    </div>
    <div className="homelinks homelinks_mobile" >
      <div className="form-inline ml-auto">
        <div className="burger_menu" onClick={ToggleSidebar}>
          <img src={Burger} />
        </div>
      </div>
      <div className={`sidebar ${isOpen==true ? 'active' : '' }`}>
        <div className="burger_menu sd-header" onClick={ToggleSidebar}>
          <img src={close} />
        </div>
        <div className="sd-body">
          <ul>
            <li>
              <Link className="sd-link active" to="/">
              <div className='home_links_class'>
                <p>Home</p>
              </div>
              </Link>
            </li>
            <li>
              <Link className="sd-link" to="/Vision">
              <div className='home_links_class'>
                <p>Our Vision/Mission</p>
              </div>
              </Link>
            </li>
            <li>
              <Link className="sd-link" to="/About">
              <div className='home_links_class'>
                <p>About Us</p>
              </div>
              </Link>
            </li>
            <li>
              <Link className="sd-link" to="/Team">
              <div className='home_links_class'>
                <p>Our Team</p>
              </div>
              </Link>
            </li>
            <li>
              <Link className="sd-link" to="/GetInvolved">
              <div className='home_links_class'>
                <p>Get Involved</p>
              </div>
              </Link>
            </li>
            <li>
              <Link className="sd-link" to="/Gallery">
              <div className='home_links_class'>
                <p>Gallery</p>
              </div>
              </Link>
            </li>
            <li>
              <Link className="sd-link" to="/Events">
              <div className='home_links_class'>
                <p>Events</p>
              </div>
              </Link>
            </li>
            <li>
              <Link className="sd-link" to="/Contact">
              <div className='home_links_class'>
                <p>Contact Us</p>
              </div>
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className={`sidebar-overlay ${isOpen==true ? 'active' : '' }`} onClick={ToggleSidebar}></div>
    </div>
  </div>
</nav>

</>
    );
}
export default Head;